import sharesproApi from 'rtkQuery/sharespro/sharesproApiService';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import mapOperationListFromApi from 'rtkQuery/sharespro/mapper/modules/operations/mapOperationsFromApi';
import mapOperationShortFromApi from 'rtkQuery/sharespro/mapper/modules/operations/mapOperationShortFromApi';
import { OperationShort } from 'model/modules/operations/operationShort';

export const operationsApi = sharesproApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchOperations: builder.query<
      PaginationList<OperationListItem>,
      ApiOperationsQueryParams
    >({
      query: (params) => ({
        url: '/v3/finance/dashboard/events',
        method: 'GET',
        sendToken: true,
        params,
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<ApiOperationsResponse>
      ) {
        return mapOperationListFromApi(baseQueryReturnValue);
      },
    }),
    searchOperations: builder.query<
      OperationShort[],
      ApiOperationSearchQueryParams
    >({
      query: (params) => ({
        url: '/v3/finance/operation/search',
        method: 'GET',
        sendToken: true,
        params,
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<ApiOperationSearchResponse>
      ) {
        return baseQueryReturnValue.data.items.map(mapOperationShortFromApi);
      },
    }),
  }),
});

export const {
  useFetchOperationsQuery,
  useSearchOperationsQuery,
} = operationsApi;
